import * as React from 'react';
import {
    Button as SemanticButton,
    Header,
    Form,
    Modal,
    Popup
} from 'semantic-ui-react';
import MediaQuery from 'react-responsive';
import { FiArrowLeft } from 'react-icons/fi';
import classNames from 'classnames';

// Global Components
import AppBar from 'components/AppBar';

// Child Components
import ButtonWithStoredSearch from '../ButtonWithStoredSearch';
// @ts-ignore
import NumberOfDaysDropdown from '../NumberOfDaysDropdown';
// @ts-ignore
import PageWrapper from '../PageWrapper';
// @ts-ignore
import SearchInput from '../SearchInput';
// @ts-ignore
import PickTypeNameDropdownSearch from './components/PickTypeNameDropdownSearch';
// @ts-ignore
import VarietyDropdownSearch from './components/VarietyDropdownSearch';
// @ts-ignore
import GroupDropdownSearch from './components/GroupDropdownSearch';
// @ts-ignore
import PersonDropdown from './components/PersonDropdown';
// @ts-ignore
import EntityTypeEntityDropdownSearches from './components/EntityTypeEntityDropdownSearches';
// @ts-ignore
import FilterButton from './components/FilterButton';
// @ts-ignore
import GlobalFilters from './components/GlobalFilters';
// @ts-ignore
import SchemaDropdown from './components/SchemaDropdown';
// @ts-ignore
import UserDropdown from './components/UserDropdown';
// @ts-ignore
import WorkTypeDropdown from './components/WorkTypeDropdown';
import RoleDropdownSearch from './components/RoleDropdownSearch';
import OnlyMyTimesheetCheckbox from './components/OnlyMyTimesheetCheckbox';

// Styles
import './styles.scss';

interface Props {
    title: string | any;
    subtitle?: string | React.ReactElement;
    backTo?: string;
    Button?: React.ReactElement;
    searchInputPlaceholder?: string | null;
    CustomSearch?: React.ReactElement | null;
    datePicker?: boolean;
    currentEntity?: boolean;
    currentSeason?: boolean;
    pickType?: boolean;
    pickTypeMultiple?: boolean;
    variety?: boolean;
    varietyMultiple?: boolean;
    group?: boolean;
    groupMultiple?: boolean;
    groupIncludeUnassignedOption?: boolean;
    person?: boolean;
    personMultiple?: boolean;
    entity?: boolean;
    entityMultiple?: boolean;
    schema?: boolean;
    schemaMultiple?: boolean;
    user?: boolean;
    userMultiple?: boolean;
    workType?: boolean;
    workTypeMultiple?: boolean;
    FirstActionButton?: React.ReactElement;
    SecondActionButton?: React.ReactElement;
    ThirdActionButton?: React.ReactElement;
    compact?: boolean;
    hideFilters?: boolean;
    roles?: boolean;
    rolesMultiple?: boolean;
    onlyMyTimesheets?: boolean;
    MessageComponent?: React.ReactElement;
}

export class PageTitleAndFilters extends React.PureComponent<Props> {
    state = { modalOpen: false };

    handleOpen = (): void => this.setState({ modalOpen: true });

    handleClose = (): void => this.setState({ modalOpen: false });

    render(): React.ReactElement {
        const {
            title,
            subtitle,
            backTo,
            Button,
            searchInputPlaceholder,
            CustomSearch,
            datePicker,
            currentEntity,
            currentSeason,
            pickType,
            pickTypeMultiple,
            variety,
            varietyMultiple,
            group,
            groupMultiple,
            groupIncludeUnassignedOption,
            entity,
            entityMultiple,
            schema,
            schemaMultiple,
            user,
            userMultiple,
            person,
            personMultiple,
            workType,
            workTypeMultiple,
            FirstActionButton,
            SecondActionButton,
            ThirdActionButton,
            compact,
            hideFilters,
            roles,
            rolesMultiple,
            onlyMyTimesheets,
            MessageComponent
        } = this.props;

        const { modalOpen } = this.state;

        const Filters = (
            <React.Fragment>
                {datePicker && (
                    <div className="page-title-and-filters-button-wrapper-dropdown-wrapper">
                        <NumberOfDaysDropdown />
                    </div>
                )}
                {pickType && (
                    <div className="page-title-and-filters-button-wrapper-dropdown-wrapper">
                        <PickTypeNameDropdownSearch
                            multiple={pickTypeMultiple}
                            clearPageOnChange
                        />
                    </div>
                )}
                {variety && (
                    <div className="page-title-and-filters-button-wrapper-dropdown-wrapper">
                        <VarietyDropdownSearch
                            multiple={varietyMultiple}
                            fluid
                            clearPageOnChange
                        />
                    </div>
                )}
                {group && (
                    <div className="page-title-and-filters-button-wrapper-dropdown-wrapper">
                        <GroupDropdownSearch
                            multiple={groupMultiple}
                            includeUnassignedOption={
                                groupIncludeUnassignedOption
                            }
                            clearPageOnChange
                        />
                    </div>
                )}
                {person && (
                    <div className="page-title-and-filters-button-wrapper-dropdown-wrapper">
                        <PersonDropdown
                            multiple={personMultiple}
                            fluid
                            clearPageOnChange
                        />
                    </div>
                )}
                {entity && (
                    <EntityTypeEntityDropdownSearches
                        multiple={entityMultiple}
                        offset={1}
                        limit={1}
                        clearPageOnChange
                    />
                )}
                {schema && (
                    <div className="page-title-and-filters-button-wrapper-dropdown-wrapper">
                        <SchemaDropdown
                            general
                            multiple={schemaMultiple}
                            fluid
                            clearPageOnChange
                        />
                    </div>
                )}
                {workType && (
                    <div className="page-title-and-filters-button-wrapper-dropdown-wrapper">
                        <WorkTypeDropdown
                            multiple={workTypeMultiple}
                            fluid
                            clearPageOnChange
                        />
                    </div>
                )}
                {user && (
                    <div className="page-title-and-filters-button-wrapper-dropdown-wrapper">
                        <UserDropdown
                            multiple={userMultiple}
                            fluid
                            clearPageOnChange
                        />
                    </div>
                )}
                {roles && (
                    <div className="page-title-and-filters-button-wrapper-dropdown-wrapper">
                        <RoleDropdownSearch
                            multiple={rolesMultiple}
                            fluid
                            clearPageOnChange
                        />
                    </div>
                )}
                {onlyMyTimesheets && (
                    <div className="page-title-and-filters-button-wrapper-checkbox-wrapper">
                        <OnlyMyTimesheetCheckbox />
                    </div>
                )}
            </React.Fragment>
        );

        return (
            <React.Fragment>
                <AppBar
                    title={title}
                    backTo={backTo}
                    Actions={
                        <React.Fragment>
                            {FirstActionButton}
                            {SecondActionButton}
                            {ThirdActionButton}
                            {!hideFilters && (
                                <Modal
                                    size="tiny"
                                    centered={false}
                                    trigger={
                                        <FilterButton
                                            onClick={this.handleOpen}
                                            style={{ color: '#fff' }}
                                        />
                                    }
                                    open={modalOpen}
                                    onClose={this.handleClose}
                                    closeIcon
                                >
                                    <Modal.Header>Filters</Modal.Header>
                                    <Modal.Content>
                                        <div className="page-title-and-filters-modal-content">
                                            {Filters}
                                        </div>
                                        <SemanticButton
                                            type="button"
                                            primary
                                            fluid
                                            onClick={this.handleClose}
                                        >
                                            Show results
                                        </SemanticButton>
                                    </Modal.Content>
                                </Modal>
                            )}
                            <div
                                style={{
                                    position: 'fixed',
                                    right: 10,
                                    bottom: 10
                                }}
                            >
                                {Button}
                            </div>
                        </React.Fragment>
                    }
                />
                <div
                    className={classNames('page-title-and-filters', {
                        compact
                    })}
                >
                    <PageWrapper top={10} bottom={0}>
                        <MediaQuery maxWidth={1024}>
                            <div className="page-title-and-filters-button-wrapper-row-responsive">
                                <GlobalFilters
                                    currentEntity={currentEntity}
                                    currentSeason={currentSeason}
                                />
                            </div>
                        </MediaQuery>
                        <MediaQuery minWidth={1025}>
                            <div className="page-title-and-filters-button-wrapper-row">
                                {backTo && (
                                    <ButtonWithStoredSearch
                                        pathname={backTo}
                                        buttonProps={{
                                            circular: true,
                                            icon: true,
                                            style: {
                                                padding: 0,
                                                background: 'transparent',
                                                boxShadow: 'none',
                                                marginRight: 10
                                            }
                                        }}
                                    >
                                        <FiArrowLeft
                                            size="22"
                                            style={{ verticalAlign: 'middle' }}
                                        />
                                    </ButtonWithStoredSearch>
                                )}
                                <Header as="h2">
                                    <Header.Content>
                                        {title}
                                        {subtitle && (
                                            <Header.Subheader
                                                as="span"
                                                style={{
                                                    display: 'inline',
                                                    marginLeft: 10
                                                }}
                                            >
                                                {subtitle}
                                            </Header.Subheader>
                                        )}
                                    </Header.Content>
                                </Header>
                                {MessageComponent}
                                <div style={{ marginLeft: 'auto' }}>
                                    <GlobalFilters
                                        currentEntity={currentEntity}
                                        currentSeason={currentSeason}
                                    />
                                    {FirstActionButton}
                                    {SecondActionButton}
                                    {ThirdActionButton}
                                    {compact && !hideFilters && (
                                        <Popup
                                            header="Filters"
                                            basic
                                            on="click"
                                            position="bottom right"
                                            trigger={<FilterButton />}
                                            content={
                                                <div className="page-title-and-filters-popup-content">
                                                    {Filters}
                                                </div>
                                            }
                                        />
                                    )}
                                    {Button && (
                                        <span className="page-title-and-filters-button-wrapper">
                                            {Button}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </MediaQuery>
                        {!compact && (
                            <div className="page-title-and-filters-button-wrapper-row-responsive">
                                <div
                                    style={{
                                        minWidth: 300
                                    }}
                                >
                                    {searchInputPlaceholder && (
                                        <SearchInput
                                            placeholder={searchInputPlaceholder}
                                        />
                                    )}
                                    {CustomSearch}
                                </div>
                                <MediaQuery minWidth={1025}>
                                    <Form>
                                        <Form.Group
                                            // HACK inline styles
                                            style={{
                                                margin: 0
                                            }}
                                        >
                                            {Filters}
                                        </Form.Group>
                                    </Form>
                                </MediaQuery>
                            </div>
                        )}
                    </PageWrapper>
                </div>
            </React.Fragment>
        );
    }
}

export default PageTitleAndFilters;
